import React, { useState } from 'react'
import './Gallery.css'
import { usePhotosList } from '../../api'
import Navigator from '../../../../components/common/Navigator'

const Gallery: React.FC = () => {
  const { data } = usePhotosList()
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const totalEvents = data?.data?.length
  const totalPages = Math.ceil(totalEvents / pageSize)
  const startIndex = (currentPage - 1) * pageSize
  const paginatedEvents = data?.data.slice(startIndex, startIndex + pageSize)

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage)
    }
  }

  const handleChangeRowsPerPage = (newSize: number) => {
    setPageSize(newSize)
    setCurrentPage(1) // reset to first page when page size changes
  }

  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 bg-white py-10 lg:my-8">
      <Navigator title="Gallery" slug="GALLERY_Photo" />
      <span className="font-barlow font-medium text-4xl leading-[40px] text-black">
        Gallery
      </span>
      <p className="text-gray-900 mb-4">Through the Lens</p>

      <hr className="border-t-2 border-primaryBlue mb-6" />

      {/* Grid with 4 images per row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
        {paginatedEvents?.map((src: any, index: number) => (
          <div key={index} className="flex flex-col cursor-pointer">
            <div
              className="relative w-full overflow-hidden rounded-md shadow-sm hover:scale-105 transition-transform duration-300"
              onClick={() => setSelectedImage(src.file)}
            >
              <img
                src={src.file}
                alt={src.title || `Gallery ${index + 1}`}
                className="w-full h-74 object-cover border border-gray-300"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Modal for full-size image */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
          {/* Close Button */}
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white text-3xl font-bold hover:text-gray-300"
          >
            &times;
          </button>

          {/* Full-size Image */}
          <img
            src={selectedImage}
            alt="Full Size"
            className="h-[600px] rounded-lg shadow-lg"
          />
        </div>
      )}
      <div className="flex justify-between px-3 pb-10 w-full">
        <div className="flex justify-center mt-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="p-2 border text-black rounded mx-1 w-12 h-10 flex items-center justify-center disabled:opacity-50"
          >
            <span>＜</span>
          </button>
          <button className="w-12 h-10 lg:w-16 md:w-14 flex items-center justify-center">
            <span className="p-2 border rounded">{currentPage}</span>
          </button>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="p-2 border text-black rounded mx-1 w-12 h-10 flex items-center justify-center disabled:opacity-50"
          >
            <span>＞</span>
          </button>
        </div>

        <div className="flex justify-center mt-4 mx-1">
          <select
            value={pageSize}
            onChange={(e) => handleChangeRowsPerPage(Number(e.target.value))}
            className="border p-2 rounded"
          >
            {[10, 20, 30, 50, 100, 200].map((size) => (
              <option key={size} value={size}>
                {size} cards
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default Gallery
